import React, { useEffect, useState } from "react";
import { Button, Table, Card, Form } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import { useGetEUforEAMutation, useGetRoutesOfEAMutation, useUpdateRoutesMappingMutation, useUserDropDownMutation } from "Services/services";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";


const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

export default () => {
  const [tableData, setTableData] = useState([]);

  const [enterprise, setEnterprise] = useState("");
  const [eOptions, setEOptions] = useState([]);
  const [enterpriseUser, setEnterpriseUser] = useState("");
  const [eUOptions, setEUOptions] = useState([]);
  const history = useHistory();

  // Get the id from localStorage
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userId = userObject.id;

  // useEffect(() => {
  //   fetchTableData();
  // }, [currentPage, pagelimit, enterprise, enterpriseRepUser])

  useEffect(() => {
    if (userType === "enterprise") {
      setEnterprise(userId);
    } else {
      fetchEnterpDropdown();
    }
  }, []);

  useEffect(() => {
    if (enterprise !== "") {
      fetchEnterpRepUserDropdown();
      fetchTableData();
    } else if (enterprise === "") {
      setEUOptions([]);
      setTableData([]);
    }
  }, [enterprise]);

  // fetch enterprise
  const [userDropDown] = useUserDropDownMutation();
  const fetchEnterpDropdown = async () => {
    try {
      const response = await userDropDown({ user_type: "4" });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setEOptions(userOptions);
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  // main table
  const [routesList] = useGetRoutesOfEAMutation();

  const fetchTableData = async () => {
    routesList({ user_id: enterprise })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.finalRouteData);
        } else {
          setTableData([]);
        }
      })
      .catch((error) => {
        alert("Error fetching user data.", error);
        setTableData([]);
      });
  };

  // fetch enterprise user
  const [reportingUserDropDown] = useGetEUforEAMutation();
  const fetchEnterpRepUserDropdown = async () => {
    setEnterpriseUser(null);
    try {
      const response = await reportingUserDropDown({ user_id: enterprise });
      if (response?.data?.statusCode === 200) {
        const userOptions = response.data.data.dropDownData.map((user) => ({
          value: user.id,
          label: user.user_name,
        }));
        setEUOptions(userOptions);
      } else {
        setEUOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setEUOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  const selectEnterp = (selectedOption) => {
    if (selectedOption != null) {
      setEnterprise(selectedOption.value);
    } else return setEnterprise("");
  };
  const selectEnterpUser = (selectedOption) => {
    if (selectedOption != null) {
      setEnterpriseUser(selectedOption.value);
    } else return setEnterpriseUser("");
  };

  // Get selected data for payload
  const [selectedData, setSelectedData] = useState([]);
  const handleRowSelect = (userId) => {
    setSelectedData((prev) => [...prev, userId]);
  };

  const [gotError, setGotError] = useState(false);

  const [updateMapping] = useUpdateRoutesMappingMutation();
  const handleSubmitSelected = async () => {
    if (!enterpriseUser || selectedData.length === 0 || !enterprise) {
      setGotError(true);
      return;
    } else {
      setGotError(false);
    }

    const postData = {
      routeId: selectedData,
      requestedEnterpriseUserId: enterpriseUser,
    };

    updateMapping(postData)
      .then((success) => {
        if (
          success?.data.statusCode >= 200 &&
          success?.data.statusCode <= 204
        ) {
          const confirmMessage = success?.data?.message || "Sucessfuly Done!";
          SwalWithBootstrapButtons.fire("Success", confirmMessage, "success");
          setTimeout(() => {
            history.push(Routes.RoutesMapping.path);
          }, 2000);
        } else {
          const confirmMessage =
            success?.data?.message || "Something went wrong!";
          SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
        }
      })
      .catch((error) => {
        const confirmMessage = error?.message || "Something went wrong!";
        SwalWithBootstrapButtons.fire("Error", confirmMessage, "error");
      });

  };

  const TableRow = (props) => {
    const statusVariant =
      props.channel === "whatsapp"
        ? "success"
        : props.channel === "sms"
          ? "info"
          : "warning";

    return (
      <tr className="border-bottom">
        {userType !== "enterprise" && (
          <td>
            <span className="fw-normal">{props.enterprise_admin}</span>
          </td>
        )}
        <td>
          <span className="fw-normal">{props.route_name}</span>
        </td>
        <td>
          <span className={`fw-normal text-${statusVariant}`}>
            {props.channel}
          </span>
        </td>
        <td>
          <input
            type="checkbox"
            style={{ cursor: "pointer" }}
            checked={selectedData.includes(props.id)}
            onChange={() => handleRowSelect(props.id)}
          />
        </td>
      </tr>
    );
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  return (
    <Card border={1}>

      <div className="d-flex flex-wrap align-items-start gap-2">
        {userType !== "enterprise" && (
          <Form.Group className="mb-3" style={{ minWidth: "250px" }}>
          <RequiredLabel label="Enterprise" />
          <Select
            // isClearable
            options={eOptions}
            className="mb-0"
            placeholder="Select User"
            value={
              eOptions.find((opt) => opt.value === enterprise) || null
            }
            onChange={(selectedOption) => {
              selectEnterp(selectedOption);
            }}
            styles={{
              control: (provided, state) => ({
                ...provided,
                borderColor: gotError && !enterprise ? '#dc3545' : gotError && !enterprise ? '#65BB82': provided.borderColor,
                borderRadius: '0.75rem',
              }),
            }}
          />
          {gotError && !enterprise && (
            <div className="invalid-feedback d-block">
              Enterprise is required.
            </div>
          )}
          </Form.Group>
        )}

        <Form.Group
          className="mb-3"
          style={{ minWidth: "250px" }}
        >
          <RequiredLabel label="Enterprise User" />
          <Select
            // isClearable
            options={eUOptions}
            placeholder="Select User"
            value={
              eUOptions.find((opt) => opt.value === enterpriseUser) ||
              null
            }
            onChange={(selectedOption) => {
              selectEnterpUser(selectedOption);
            }}
            styles={{
              control: (provided, state) => ({
                ...provided,
                borderColor: gotError && !enterpriseUser ? '#dc3545' : gotError && enterpriseUser ? '#65BB82': provided.borderColor,
                borderRadius: '0.75rem',
              }),
            }}
          />
          {gotError && !enterpriseUser && (
            <div className="invalid-feedback d-block">
              Enterprise User is required.
            </div>
          )}
        </Form.Group>
      </div>


      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table responsive className="align-items-center table-flush table-outlines">
            <thead className="thead-light">
              <tr>
                {userType !== "enterprise" && (
                  <th className="border-bottom">Enterprise</th>
                )}
                <th className="border-bottom">Route</th>
                <th className="border-bottom">Channel</th>
                <th className="border-bottom">Select</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? (
                tableData.map((u, index) => <TableRow key={index} {...u} />)
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {gotError &&  selectedData.length === 0 && (
        <div className="invalid-feedback d-block">
          Select atleast one Route.
        </div>
      )}
      <Card.Footer className="mt-3 p-0 border-0 d-flex flex-wrap align-items-center justify-content-end">
        <Button
          variant="secondary"
          className="my-2"
          type="submit"
          onClick={handleSubmitSelected}
        >
          Save
        </Button>
      </Card.Footer>
    </Card>

  );
};
